import moment from "moment";


const userToMomentFormatMap = {
  "MM/dd/yyyy": "MM/DD/YYYY",
  "dd/MM/yyyy": "DD/MM/YYYY",
  "yyyy/MM/dd": "YYYY/MM/DD",
  "yyyy-MM-dd": "YYYY-MM-DD",
  "MMM dd, yyyy": "MMM DD, YYYY",
  "MMMM dd, yyyy": "MMMM DD, YYYY",
  "MM dd, yyyy": "MMMM DD, YYYY", // override interpretation to match desired output
  };


const getDateFormat = () => {
  const userFormat = localStorage.getItem("dateFormat") || "yyyy/MM/dd";
  return userToMomentFormatMap[userFormat] || "YYYY/MM/DD";
};

const getDateTimeFormat = () => localStorage.getItem("dateFormatWithTime") || "YYYY/MM/DD HH:mm";

// Reusable render function for just the date
export const renderDate = (date) => {

  const format = getDateFormat();
 /// alert( moment(date).isValid() ? moment(date).format(format) : format)
  return moment(date).isValid() ? moment(date).format(format) : format;
};

// Reusable render function for date + time
export const renderDateTime = (date) => {
  const format = getDateTimeFormat();
  return moment(date).isValid() ? moment(date).format(format) : format;
};
